<template>
  <a-form-item :label="field.name">
    <a-input
      placeholder="Vui lòng nhập dòng chữ"
      :value="value"
      @change="onChange"
    />
    <!-- <a-input
      v-decorator="[
        field.code,
        { rules: [{ required: true, message: 'Please input your note!' }] },
      ]"
    /> -->
  </a-form-item>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: String,
  },
  methods: {
    onChange(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>
